import { ImageEvalDemo } from "@/components/image-eval-demo";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/image-eval-demo")({
  component: RouteComponent,
});

function RouteComponent() {
  return <ImageEvalDemo />;
}
